/** @format */
import { MarketLanguage } from '@mpb-com/feather/enums';

// eslint-disable-next-line boundaries/entry-point -- can't figure out how to fix this
import { languagesWithImpressum } from '../config/language';

export const hasImpressum = (language: MarketLanguage) => {
    return languagesWithImpressum.includes(language);
};
